<template>
	<div id="paike">
		<div class="fflex fflexV fflexbet">
			<div>
				<span>修改记录</span>
				<el-button size="mini" round class="boxshadow " :class="{activex:(xuan==pki)}" @click="zhouqs(pki,pk.start_time,pk.end_time)"
				 v-for="(pk,pki) in pk_records" :key="pki">{{pk.start_time_status}}<span v-if="pki == xuan">--{{pk.end_time}} ({{pk.diff_week}}周)</span>
					<!--<i class="el-icon-error" style="margin-left: 5px;"></i>-->
				</el-button>
			</div>
			<div>
				<el-button size="mini" round class="boxshadow" @click="xiugaipaike">修改排课周期</el-button>
				<el-button size="mini" round @click="ylfbfn">月龄分布</el-button>
				<el-button size="mini" round @click="fanhui">返回</el-button>
			</div>
		</div>

		<!--修改弹窗s-->
		<el-dialog class="tanchuang" title="修改排课" :visible.sync="xgt" width="430px">
			<div>
				<div style="margin-bottom: 20px">
					<span>选择要修改的排课</span>
					<el-button size="mini" round class="boxshadow" :class="{activex:xiuindex==kindex}" v-for="(btn,kindex) in kebtn"
					 :key="kindex" @click="xgpk(kindex,btn.start_time,btn.end_time)">{{btn.start_time}}</el-button>
				</div>
				<!-- <div style="margin-bottom: 20px">
					<span>课程周期</span>
					<select name="" class="xiala" @change="zhoufnX" v-model="zhouX" style="margin-left: 20px;width: 250px" id="">
						<option value="12">12周</option>
						<option value="1">1周</option>
						<option value="2">2周</option>
						<option value="3">3周</option>
						<option value="4">4周</option>
						<option value="5">5周</option>
						<option value="6">6周</option>
						<option value="7">7周</option>
						<option value="8">8周</option>
						<option value="9">9周</option>
						<option value="10">10周</option>
						<option value="11">11周</option>
					</select>
				</div> -->
				<div style="margin-bottom: 20px">
					<span style="margin-right: 20px;margin-bottom: 20px;">开始时间</span>
					<el-date-picker v-model="stimeX" size="mini" value-format="yyyy-MM-dd" style="width: 250px;margin-bottom: 20px;"
					 type="date" placeholder="选择日期">
						<!--:picker-options="pickerOptions0"-->
					</el-date-picker>
					<br />
					<span style="margin-right: 20px">结束时间</span>

					<el-date-picker value-format="yyyy-MM-dd" v-model="etimeX" size="mini" style="width: 250px"
					 type="date" placeholder="选择日期">
					</el-date-picker>
				</div>
				<p style="font-size:12px ;line-height: 20px;color:#79c4c7;text-align: left">
					注释：此处为修改已有排课记录的排课时间，修改后不会生成新的排课记录。如需生成新的排课请点击一键排课。
				</p>
			</div>
			<div slot="footer" style="text-align: center">
				<el-button size="mini" round style="background: #E6BE8A;color: #fff" @click="xiu_confirm">确定</el-button>
			</div>
		</el-dialog>
		<!--修改弹窗e-->

		<div style="width: 100%;overflow-x: scroll">
			<table class="table table-bordered" style="width: auto;table-layout: fixed;box-shadow: none;margin-top: 10px;margin-bottom: 10px">
				<thead>
					<tr>
						<th style="width: 140px!important;background: #fff;padding:0  10px 0 0;">
							<select name="" v-model="week" class="xiala" @change="zhoucha" style="background:#E6BE8A;color: #fff;width: 128px ">
								<option value="1">星期一</option>
								<option value="2">星期二</option>
								<option value="3">星期三</option>
								<option value="4">星期四</option>
								<option value="5">星期五</option>
								<option value="6">星期六</option>
								<option value="7">星期日</option>
							</select>
						</th>
						<th style="width: 160px" v-for="k in class_room_names">{{k.content}}</th>
						<!--<th style="width: 160px">综合教室</th>-->
						<!--<th style="width: 160px">综合教室</th>-->
						<!--<th style="width: 160px">综合教室</th>-->
						<!--<th style="width: 160px">综合教室</th>-->
						<!--<th style="width: 160px">综合教室</th>-->
					</tr>
				</thead>
				<tbody id="tbody">

					<tr v-for="(it,iidex) in infos" class="fuzhi" :key="iidex">
						<td style="padding:5px  10px 5px 0;" v-for="(kks,index) in it" v-if="index==0">

							<div class="fflex fflexC boxshadow" style="background:#f1f1f1;flex-wrap: wrap;border-radius: 5px;padding: 5px "
							 @click="startT(kks)">
								<div class="fflex fflexV" style="margin-bottom: 5px">
									<span>上课时间：</span>
								</div>
								<!--<div class="fflex fflexV" >-->
								<TimePicker class="sjcj" format="HH:mm" style="width: 100px" type="timerange" @on-change="startTimeChange"
								 :disabled-hours="[0,1,2,3,4,5,6,7,23]" hide-disabled-options :steps="[1, 5, 1]" :value="kks" placement="bottom-start"
								 placeholder="选择上课时间"></TimePicker>
							</div>
						</td>
						<td style="padding:5px  10px 5px 0;" v-for="(kk,index) in it" v-if="index>0" @click="pkid(kk.pk_id,kk.kc_id,kk.user_id)">
							<div class="fflex fflexC boxshadow" style="background:#fff;flex-wrap: wrap;border-radius: 5px;padding: 5px;width: 160px ">
								<!--<input type="text" v-model="kk.pk_id" v-if="kk.pk_id">-->
								<div class="fflex fflexV" style="margin-bottom: 5px">
									<span>课程/班级：</span> <select v-model="kk.kc_id" class="xiala" @change="xiugai(kk.kc_id,kk.user_id,kk.xiaoke,kk.s_time,kk.x_time)"
									 style="width: 70px;padding: 0">
										<option value="">请选择</option>
										<option v-for="ke in need_classes[index-1].classes" :value="ke.kc_id">{{ke.kc_name}}</option>
										<!-- <option :value="ke.kc_id" v-for="ke in classes">{{ke.kc_name}}</option> -->
									</select>
								</div>
								<div class="fflex fflexV" style="margin-bottom: 5px">
									<span>老师名称：</span> <select v-model="kk.user_id" class="xiala" @change="xiugai(kk.kc_id,kk.user_id,kk.xiaoke,kk.s_time,kk.x_time)"
									 style="width: 70px;padding: 0">
										<option value="">请选择</option>
										<option :value="te.user_id" v-for="te in teachers">{{te.username}}</option>
									</select>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<!--width: 130px;height: 60px;-->
		<div @click="zengjia" class="fflex fflexC fflexV boxshadow" style="border-radius: 5px;background: #fff;margin-right: 20px;display: inline-block;padding: 6px 0 0 6px;float: left;">
			<img src="/static/qmsj/img/xinzeng.png" style="width: 115px;box-shadow: 3px 3px 3px lavender;cursor: pointer;" alt="">
		</div>
        <div @click="del_course" class="fflex fflexC fflexV boxshadow" style="border-radius: 5px;background: #fff;margin-right: 20px;display: inline-block;padding: 6px 0 0 6px;float: left;">
            <img src="/static/qmsj/img/shanchukong.png" style="width: 115px;box-shadow: 3px 3px 3px lavender;cursor: pointer;" alt="">
        </div>
		<!--width: 130px;height: 60px;-->
		<!--<div @click="del_course" class="fflex fflexC fflexV boxshadow" style="border-radius: 5px;background: #fff;margin-right: 20px;display: inline-block;padding: 6px 0 0 6px;">-->
			<!--<img src="/static/qmsj/img/shanchukong.png" style="width: 120px;cursor: pointer;" alt="">-->
		<!--</div>-->
		<!-- <el-button size="mini" style="padding: 10px 20px;" @click="del_course">删除未排课</el-button> -->
		<!--<div>-->
		<!--开始时间-->

		<!--<el-time-picker-->
		<!--@change="shuchuTime"-->

		<!--v-model="startTime"-->
		<!--:picker-options="{-->
		<!--selectableRange: '00:00:00 - 23:30:00'-->
		<!--}"-->
		<!--&gt;-->
		<!--</el-time-picker>-->


		<!--结束时间：-->

		<!--<el-time-picker-->
		<!--v-model="endTime"-->

		<!--:picker-options="{-->

		<!--selectableRange: sstartTime+' - 23:30:00'-->

		<!--}"-->
		<!--&gt;-->
		<!--</el-time-picker>-->

		<!--</div>-->
		<!--月龄分布s-->
		<el-dialog class="tanchuang" title="月龄分布" :visible.sync="ylfb" width="360px">
			<div style=" background: url(/static/qmsj/img/lanshux.png) no-repeat center center;background-size: 2px 100%;text-align: center">
				<el-row>
					<el-col :span="12" v-for="(yl,yli) in ylfbdata1" :key="yli">
						{{yl.yue}} ：{{yl.shu}}人
					</el-col>
					<el-col :span="12" v-for="(yl,yli) in ylfbdata2" :key="yli">
						{{yl.yue}} ：{{yl.shu}}人
					</el-col>
					<el-col :span="12" v-for="(yl,yli) in ylfbdata3" :key="yli">
						{{yl.yue}} ：{{yl.shu}}人
					</el-col>
				</el-row>
			</div>
		</el-dialog>
		<!--月龄分布e-->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				stime: '',
				etime: '',
				pickerOptions0: {
					disabledDate: ''
				},
				zhou: '12',
				startTime: new Date(1989, 1, 8, 0, 0),
				endTime: new Date(1989, 1, 8, 0, 0),
				sstartTime: '',
				token: '',
				class_room_names: '',
				classes: '',
				need_classes: [],
				teachers: '',
				infos: '',
				zhouX: '',
				week: '1',
				pk_records: '',
				xuan: '',
				ylfb: false,
				ylfbdata1:[],
				ylfbdata2:[],
				ylfbdata3:[],
				pk_id: "",
				oldkic: '',
				olduid: '',
				s_time: '',
				e_time: '',
				os_time: '',
				oe_time: '',
				okais: '',
				ojieshu: '',
				xgt: false,
				stimeX: '',
				etimeX: '',
				kebtn: '',
				xiuindex: "",
				xiu_start: '',
				xiu_end: '',
				week: '3',
				kjl: '',
				xuan: '',
			}
		},
		methods: {
			//删除未排课行
			del_course(){
				let that = this;
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/clear_pk',
					dataType: 'json',
					type: 'post',
					data: {
						token: that.token,
						week: that.week,
						start_time: that.shaist,
						end_time: that.shaiet,
					},
					success: function(res) {
						if (res.status == 1) {
							that.get_data()
							that.$message({
								message:res.msg,
								type:'success'
							})
						} else {
							that.$message.error(res.msg)
						}
					}

				})
			},
			get_data(){
				let self = this
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/index',
					dataType: 'json',
					type: 'post',
					data: {
						token: self.token,
						type: 3,
						start_time: self.shaist,
						end_time: self.shaiet,
						week: self.week
					},
					success: function(data) {
						self.class_room_names = data.data.class_room_names;
						self.classes = data.data.classes;
						self.need_classes = data.data.need_classes;
						self.teachers = data.data.teachers;
						self.infos = data.data.infos;
						self.pk_records = data.data.pk_records;
						for (var i = 0; i < data.data.pk_records.length; i++) {
							if (data.data.pk_records[i].chose == 1) {
								self.xuan = i
								self.shaist = data.data.pk_records[i].start_time;
								self.shaiet = data.data.pk_records[i].end_time;
							}
						}
					}
				})
			},
			xiugaipaike: function() {
				this.xgt = true
				let self = this;
				self.stimeX = ""
				self.etimeX = ""
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/zhouke',
					dataType: 'json',
					type: 'post',
					data: {
						token: this.token
					},
					success: function(data) {
						if (data.status == 1) {
							self.kebtn = data.data.cycles
							self.xiuindex = 0
							self.xiu_start = data.data.cycles[0].start_time
							self.xiu_end = data.data.cycles[0].end_time
						} else {
							self.$message.error('没有课程统计记录')
						}
					}
				})
			},
			// 修改排课（弹窗）
			xgpk: function(i, s, e) {
				this.xiuindex = i
				this.xiu_start = s
				this.xiu_end = e
			},
			// 修改排课确认（弹窗）
			xiu_confirm: function() {
				if (this.stimeX == '' || this.stimeX == null ){
					this.$message.error('请选择开始时间')
					return
				}
				if ( this.etimeX == '' || this.etimeX == null ){
					this.$message.error('请选择结束时间')
					return
				}
				if ( this.stimeX > this.etimeX ){
					this.$message.error('开始时间不能大于结束时间')
					return
				}
				let self = this;
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/modify_pk_cycle',
					dataType: 'json',
					type: 'post',
					data: {
						token: self.token,
						x_start_time: self.stimeX,
						x_end_time: self.etimeX,
						y_start_time: self.xiu_start,
						y_end_time: self.xiu_end,
						type: 3
					},
					success: function(data) {
						if (data.status == 1) {
							self.$message.success(data.msg)
							self.xgt = false
							self.shai()
							self.fanhui();
						} else {
							self.$message.error(data.msg)
						}
					}
				})
			},
			shai: function() {
				let self = this;
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/index',
					dataType: 'json',
					type: 'post',
					data: {
						type: 1,
						token: self.token,
						start_time: self.shaist,
						end_time: self.shaiet,
						week: self.week
					},
					success: function(data) {
						self.kjl = data.data;
						for (var i = 0; i < data.data.pk_records.length; i++) {
							if (data.data.pk_records[i].chose == 1) {
								self.xuan = i
							}
						}
					}
				})
			},
			zhoufnX: function() {
				let self = this;
				let zhounum = Number(self.zhouX)
				let d = new Date(self.stimeX).getTime() + 86400000 * 7 * zhounum - 86400000;
				function timestampToTime(timestamp) {
					var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
					var Y = date.getFullYear() + '-';
					var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
					var D = date.getDate()  < 10 ? '0' + (date.getDate()) : date.getDate();
					var h = date.getHours() + ':';
					var m = date.getMinutes() + ':';
					var s = date.getSeconds();
					return Y + M + D;
				}
				this.etimeX = timestampToTime(d)
			},
			stfnX: function() {
				let self = this;
				let zhounum = Number(self.zhouX)
				let d = new Date(self.stimeX).getTime() + 86400000 * 7 * zhounum - 86400000;
				function timestampToTime(timestamp) {
					var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
					var Y = date.getFullYear() + '-';
					var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
					//                var D = date.getDate() + ' ';
					var D = date.getDate()  < 10 ? '0' + (date.getDate()) : date.getDate();
					var h = date.getHours() + ':';
					var m = date.getMinutes() + ':';
					var s = date.getSeconds();
					//                return Y+M+D+h+m+s;
					return Y + M + D;
				}
				this.etimeX = timestampToTime(d)
			},
			stfn2X: function() {
				let self = this;
				let zhounum = Number(self.zhouX)
				let d = new Date(self.stimeX).getTime() + 86400000 * 7 * zhounum - 86400000;
				function timestampToTime(timestamp) {
					var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
					var Y = date.getFullYear() + '-';
					var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
					//                var D = date.getDate() + ' ';
					var D = date.getDate()  < 10 ? '0' + (date.getDate()) : date.getDate();
					var h = date.getHours() + ':';
					var m = date.getMinutes() + ':';
					var s = date.getSeconds();
					return Y + M + D;
				}
				this.etimeX = timestampToTime(d)
			},
			fanhui: function() {
				this.$router.push({
					'name': 'paikejl'
				})
			},
			ylfbfn: function() {
				this.ylfb = true;
				let self = this;
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/yueling',
					dataType: 'json',
					type: 'post',
					data: {
						token: this.token,
						start_num:0,
						end_num:4
					},
					success: function(data) {
						if(data.status == 1){
							self.ylfbdata1 = data.data
							self.ylfbfn1()
							self.ylfbfn2()
						}
					}
				})
			},
			ylfbfn1: function() {
				this.ylfb = true;
				let self = this;
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/yueling',
					dataType: 'json',
					type: 'post',
					data: {
						token: this.token,
						start_num:5,
						end_num:9
					},
					success: function(data) {
						self.ylfbdata2 = data.data
					}
				})
			},
			ylfbfn2: function() {
				this.ylfb = true;
				let self = this;
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/yueling',
					dataType: 'json',
					type: 'post',
					data: {
						token: this.token,
						start_num:10,
						end_num:14
					},
					success: function(data) {
						self.ylfbdata3 = data.data
					}
				})
			},
			xiugai: function(kid, uid, xh, st, et) {
				let self = this;
				self.token = $.cookie('token');
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/do_pk_update',
					dataType: 'json',
					type: 'post',
					data: {
						token: self.token,
						pk_id: self.pk_id,
						kc_id: kid,
						user_id: uid,
						week: self.week,
						xiaoke: xh,
						start_time: self.stime,
						end_time: self.etime,
						before_kc_id: self.oldkic,
						before_user_id: self.olduid,
						s_time: st,
						x_time: et
					},
					success: function(data) {

						if (data.status == 1) {
							self.getindex()
						} else {
							alert(data.msg);
							self.getindex()
						}

					}
				})
			},
			startT: function(e) {
				this.os_time = e[0]
				this.oe_time = e[1]
			},
			zhoucha: function() {
				let self = this;
				self.getindex()
			},
			pkid: function(pk_id, oldkic, olduid) {
				if (pk_id) {
					this.pk_id = pk_id
					this.oldkic = oldkic
					this.olduid = olduid
				}
			},
			zhouqs: function(pk, stime, etime) {
				this.xuan = pk;
				this.shaist = stime;
				this.shaiet = etime;
				this.stime = stime;
				this.etime = etime;
				let self = this;
				self.shai();
			},
			shai: function() {
				let self = this;
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/index',
					dataType: 'json',
					type: 'post',
					data: {
						type: 3,
						token: self.token,
						start_time: self.shaist,
						end_time: self.shaiet,
						week: self.week
					},
					success: function(data) {
						self.class_room_names = data.data.class_room_names;
						self.classes = data.data.classes;
						self.need_classes = data.data.need_classes;
						self.teachers = data.data.teachers;
						self.infos = data.data.infos;
						self.pk_records = data.data.pk_records;
						for (var i = 0; i < data.data.pk_records.length; i++) {
							if (data.data.pk_records[i].chose == 1) {
								self.xuan = i
							}
						}
					}
				})
			},
			startTimeChange: function(e) {
				if ((typeof e) != 'object') {
					return;
				} else {
					if (e[0] >= e[1]) {
						return;
					} else {
						this.s_time = e[0];
						this.e_time = e[1];

						let stime = e[0];
						let etime = e[1];

						const loading = this.$loading({
							lock: true,
							text: '加载中...',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						let self = this;
						$.ajax({
							url: process.env.apiUrl + 'saas/paike/do_pk',
							dataType: 'json',
							type: 'post',
							data: {
								token: this.token,
								s_time: stime,
								x_time: etime,
								start_time: self.stime,
								end_time: self.etime,
								week: self.week,
								y_s_time: self.os_time,
								y_x_time: self.oe_time,
							},
							success: function(data) {
								if (data.status == 1) {
									self.getindex();
									loading.close();
								} else {
									alert(data.msg);
									self.getindex();
									loading.close();
								}
							}
						})
					}
				}
			},
			zengjia: function() {
				var arr = [
					["", ""]
				]
				for (var i = 0; i < this.class_room_names.length; i++) {
					arr.push([])
				}
				this.infos.push(arr)
			},
			getindex: function() {

				let self = this;
				self.token = $.cookie('token');

				$.ajax({
					url: process.env.apiUrl + 'saas/paike/index',
					dataType: 'json',
					type: 'post',
					data: {
						token: self.token,
						type: 1,
						start_time: self.stime,
						end_time: self.etime,
						week: self.week,
					},
					success: function(data) {
						self.class_room_names = data.data.class_room_names;
						self.need_classes = data.data.need_classes;
						self.classes = data.data.classes;
						self.teachers = data.data.teachers;
						self.infos = data.data.infos;
					}
				})
			},
			shuchuTime: function() {
				let time = new Date(this.startTime).getTime() + 60000 * 45;

				function timestampToTime(timestamp) {
					var date = new Date(timestamp)
					var h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
					var m = date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes() + ':';
					var s = date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds();
					return h + m + s;
				}

				this.endTime = new Date(time)
				this.sstartTime = timestampToTime(time)

			},
			stfn: function() {
				let self = this;
				let zhounum = Number(self.zhou)
				let d = new Date(self.stime).getTime() + 86400000 * 7 * zhounum - 86400000;

				function timestampToTime(timestamp) {
					var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
					var Y = date.getFullYear() + '-';
					var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
					//                var D = date.getDate() + ' ';
					var D = date.getDate()  < 10 ? '0' + (date.getDate()) : date.getDate();
					var h = date.getHours() + ':';
					var m = date.getMinutes() + ':';
					var s = date.getSeconds();
					//                return Y+M+D+h+m+s;
					return Y + M + D;
				}

				this.etime = timestampToTime(d)
			},
			stfn2: function() {
			},
			zhoufn: function() {
				let self = this;
				let zhounum = Number(self.zhou)
				let d = new Date(self.stime).getTime() + 86400000 * 7 * zhounum - 86400000;

				function timestampToTime(timestamp) {
					var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
					var Y = date.getFullYear() + '-';
					var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
					//                var D = date.getDate() + ' ';
					var D = date.getDate()  < 10 ? '0' + (date.getDate()) : date.getDate();
					var h = date.getHours() + ':';
					var m = date.getMinutes() + ':';
					var s = date.getSeconds();
					//                return Y+M+D+h+m+s;
					return Y + M + D;
				}

				this.etime = timestampToTime(d)
				//        Date.prototype.Format = function (fmt) {
				//            var o = {
				//                "M+": this.getMonth() + 1, //月份
				//                "d+": this.getDate(), //日
				//                "h+": this.getHours(), //小时
				//                "m+": this.getMinutes(), //分
				//                "s+": this.getSeconds(), //秒
				//                "q+": Math.floor((this.getMonth() + 3) / 3), //季度
				//                "S": this.getMilliseconds() //毫秒
				//            };
				//            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
				//            for (var k in o)
				//                if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
				//            return fmt;
				//        }
				//            this.etime= new Date(d).Format("yyyy-MM-dd");
				//Format("输入你想要的时间格式:yyyy-MM-dd,yyyyMMdd")
				//
				//
				//
				//
				//
				//            this.etime=d;
			},
		},
		mounted: function() {
			this.token = $.cookie('token');
			let self = this;
			self.shaist = self.$route.query.start;
			self.shaiet = self.$route.query.end;
			self.stime = self.$route.query.start;
			self.etime = self.$route.query.end;
			self.week = self.$route.query.week;

			$.ajax({
				url: process.env.apiUrl + 'saas/paike/index',
				dataType: 'json',
				type: 'post',
				data: {
					token: this.token,
					type: 3,
					start_time: self.shaist,
					end_time: self.shaiet,
					week: self.week
				},
				success: function(data) {
					self.class_room_names = data.data.class_room_names;
					self.classes = data.data.classes;
					self.need_classes = data.data.need_classes;
					self.teachers = data.data.teachers;
					self.infos = data.data.infos;
					self.pk_records = data.data.pk_records;
					for (var i = 0; i < data.data.pk_records.length; i++) {
						if (data.data.pk_records[i].chose == 1) {
							self.xuan = i
							self.shaist = data.data.pk_records[i].start_time;
							self.shaiet = data.data.pk_records[i].end_time;

						}
					}
				}
			})

		}


	}
</script>

<style scoped>
	#paike {
		min-height: 100%;
		background: #f8f8f8;
		margin: 0;
		padding: 9px;
		box-sizing: border-box;
		color: #666;
		font-size: 12px;
	}

	#paike * {
		box-sizing: border-box;
	}

	#paike ul,
	p,
	label {
		margin: 0;
		padding: 0;
	}

	.xiala {
		width: 140px;
		height: 28px;
		line-height: 28px;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: 13px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);

	}

	.activex {
		color: #E6BE8A;
		border-color: #E6BE8A;
	}
</style>
<style>
	#paike .sjcj .el-input--suffix .el-input__inner {
		padding-right: 0;
		padding-left: 5px;
	}

	#paike .sjcj .el-input__prefix {
		display: none;
	}

	#paike .sjcj .el-input__icon .el-icon-time {
		display: none;
	}

	#paike .sjcj .el-input__inner {
		padding-right: 0;
		padding-left: 5px;
	}

	#paike .ivu-input-icon {
		display: none;
	}

	#paike .ivu-input-icon-normal+.ivu-input {
		padding-right: 0;
	}

	.el-button--mini.is-circle {
		padding: 1px;
		margin-left: 5px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/paike/paikexiu.vue